import { initialState } from './consts'
import { handleFetchAdmin } from './admin'
import { handleUnsubscribeUser } from './unsubscribeUser'
import { handleReplaceUser } from './replaceUser'
import { handleSubscribeUser } from './subscribeUser'
import { handleRemoveUser } from './removeUser'
import { handleReplaceUserSubscription } from './replaceUserSubscription'
import { handleGetInvoices } from './getInvoices'

const adminDashboardReducer = (state = initialState, action = {}) => {
  state = handleFetchAdmin(state, action)
  state = handleSubscribeUser(state, action)
  state = handleUnsubscribeUser(state, action)
  state = handleReplaceUser(state, action)
  state = handleRemoveUser(state, action)
  state = handleReplaceUserSubscription(state, action)
  state = handleGetInvoices(state, action)
  return state
}

export default adminDashboardReducer
